import { render, staticRenderFns } from "./Wp_jd_sku_detail_page.vue?vue&type=template&id=7d75d7de&scoped=true&xmlns%3Av-clipboard=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./Wp_jd_sku_detail_page.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_sku_detail_page.vue?vue&type=script&lang=js&"
import style0 from "./Wp_jd_sku_detail_page.vue?vue&type=style&index=0&id=7d75d7de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d75d7de",
  null
  
)

export default component.exports